import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { USER_DEFAULT_DATA } from "../../constants/user-profile";
import { TSearchType, TUserFromServer } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetUsersData = async ({
  searchType,
  condition,
  value,
  userName,
  userNationality,
  userResidenceCountry,
  userAge,
  userHeight,
  userWeight,
  userDescription,
  userPeerDescription,
  userAccountCreatedOn
}: {
  searchType: TSearchType;
  condition: string;
  value: string;
  userName: string;
  userNationality: string;
  userResidenceCountry: string;
  userAge: number;
  userHeight: number;
  userWeight: number;
  userDescription: string;
  userPeerDescription: string;
  userAccountCreatedOn: string;
}): Promise<{
  data: TUserFromServer[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TUserFromServer[]>(
    `user/getUsersData`,
    {
      searchType,
      condition,
      value,
      userName,
      userNationality,
      userResidenceCountry,
      userAge,
      userHeight,
      userWeight,
      userDescription,
      userPeerDescription,
      userAccountCreatedOn
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: USER_DEFAULT_DATA,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: USER_DEFAULT_DATA,
      status: "ERROR",
      code: "ERROR"
    };
  }
};
